import { Clickable, Row, Text } from 'components';
import { theme } from 'lib';

const TagButton = ({ onClick, text, selected }) => {
  const displaySelected =
    typeof selected === 'string' ? selected === text : selected.includes(text);

  function handleClick() {
    onClick(text);
  }

  if (!text) return null;

  return (
    <Clickable onClick={handleClick}>
      <Row
        ht="40px"
        center
        bg={displaySelected ? theme.SECONDARY_20 : theme.GREY_10}
        hasBorder={displaySelected && `1px solid ${theme.SECONDARY}`}
        hasRadius="32px"
      >
        <Text marg="0 24px">{text}</Text>
      </Row>
    </Clickable>
  );
};

export default TagButton;
